import { LoadingSkeleton } from '../../../../common/components';
import GerencialesPieTableSection from '../GerencialesPieTableSection';
import { PIE_ALLOWED_COLORS } from '../../constants/gerencialesConstants';

/**
 * Renderiza el informe de pagos por entidad legal.
 * @param {Object} props - Props del componente.
 * @param {boolean} props.loading - Estado de carga.
 * @param {Array<Object>|null} props.results - Resultados del reporte.
 * @param {Object|null} props.header - Header con metadata.
 * @returns {JSX.Element|null} Informe de pagos.
 */
const PaymentsReport = ({ loading, results, header }) => {
  if (loading) {
    return <LoadingSkeleton />;
  }

  if (!results) {
    return null;
  }

  const rows = Array.isArray(results) ? results : [];

  const palette = PIE_ALLOWED_COLORS;
  const pieData = rows.map((row, index) => ({
    name: row?.legal_entity_name ?? 'Sin dato',
    value: Number(row?.count ?? 0),
    fill: palette[index % palette.length],
  }));

  return (
    <GerencialesPieTableSection
      title="Pagos por entidad legal"
      columns={[
        { key: 'legal_entity_name', label: 'Entidad legal', align: 'left' },
        { key: 'count', label: 'Pagos', align: 'center' },
      ]}
      rows={rows}
      pieData={pieData}
      totalLabel="Total pagos"
      totalCount={header?.total_payments ?? 0}
      chartId="gerenciales-payments-report-legal-entity"
    />
  );
};

export default PaymentsReport;
